import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Missions from "./pages/Missions";
import Contact from "./pages/Contact";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/missions" element={<Missions />} />
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                    <Footer />
                    <Toaster
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                fontFamily: "Manrope, sans-serif",
                                borderRadius: 4,
                                border: "1px solid #E4E4E7",
                            },
                        }}
                    />
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
